module.exports = __webpack_public_path__ + "static/img/icon-rate.b04d01b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-rate.png
// module id = v2os
// module chunks = 1